import React from 'react';
import { ParentAccountsController } from 'src/components/enterprise/Parents/Accounts/ParentAccountsController/ParentAccountsController';
import { useCanAccessParentAdminFlows } from 'src/components/enterprise/Parents/Admin/hooks/useCanAccessParentAdminFlows/useCanAccessParentAdminFlows';

export const ParentAccounts: React.FC = () => {
  const isUserAllowedAccess = useCanAccessParentAdminFlows();

  if (!isUserAllowedAccess) {
    return null;
  }

  return <ParentAccountsController />;
};
